import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { UploadFileComponent } from './upload-file.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule
  ],
  declarations: [
    UploadFileComponent
  ],
  exports: [
    MatButtonModule,
    MatInputModule,
    UploadFileComponent
  ]
})
export class UploadFileModule { }
